var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.587 0.158C372.816 3.53 320 62.853 320 131.706L320 224H64C28.654 224 0 252.654 0 288V448C0 483.346 28.654 512 64 512H384C419.346 512 448 483.346 448 448V288C448 252.654 419.346 224 384 224H336L336 131.255C336 71.024 382.184 19.118 442.341 16.14C506.65 12.957 560 64.374 560 128V216C560 220.418 563.582 224 568 224L568 224C572.418 224 576 220.418 576 216V128C576 55.296 515.084 -3.447 441.587 0.158ZM384 240C410.469 240 432 261.531 432 288V448C432 474.469 410.469 496 384 496H64C37.531 496 16 474.469 16 448V288C16 261.531 37.531 240 64 240H384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.192ddeaa0ea95382bf2290e7fc7bffab.svg";
export { ForwardRef as ReactComponent };